var plugin_rtlignore_default = {
  "alignLeft": "_5oKrM",
  "textWrapNowrap": "dNqaD",
  "alignRight": "_2GTRH",
  "alignCenter": "ZjUDk",
  "sizeFullWidth": "LVZAA",
  "renderedInTable": "vcaMl",
  "sizeOriginal": "-qQ52",
  "sizeContent": "OlWrF",
  "sizeSmall": "H-Nku",
  "sizeSmallCenter": "mcuVA",
  "flex": "xT3kf",
  "atomic": "uih3A",
  "anchor": "_65uO9",
  "embed": "_4i-F2",
  "horizontalScrollbar": "_1xVVZ",
  "pluginContainerMobile": "BVXQF"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
